import { useQuery } from "@graphcommerce/graphql";
import { Image } from "@graphcommerce/image";
import { ProductListDocument } from "@graphcommerce/magento-product";
import { CategorySearchDocument } from "@graphcommerce/magento-search";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import IconSearch from "../icons/IconSearch";
import Loading from "../icons/Loading";

export default React.forwardRef(({ open }: { open?: boolean; },
  ref) => {
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState<any>(null)
  const [show, setShow] = useState(false);
  const { refetch: getProducts } = useQuery(ProductListDocument, { skip: true });
  const { refetch: getCategores } = useQuery(CategorySearchDocument, { skip: true })
  const [pData, setPData] = useState<any>(undefined);
  const [cData, setCData] = useState<any>(undefined);
  const [text, setText] = useState<string>('')


  const handleSearch = (search: string) => {

    setLoading(() => true);
    setSearchTerm(search)
    Promise.all([
      getProducts({
        search,
        pageSize: 5
      }),
      getCategores({
        pageSize: 10,
        search
      })
    ]).then((res) => {
      setPData(() => res[0].data.products?.items)
      setCData(() => res[1].data.categories?.items)
      setLoading(false);
      setShow(true)
    })
  }

  useEffect(() => {

    const timer = setTimeout(() => {
      if (text?.length > 2)
        handleSearch(text)
    }, 500);
    return () => clearTimeout(timer)
  }, [text])
  return (
    <div
      className="flex-1 max-w-[95%] md:max-w-2xl relative  m-auto"
    >
      <div className="relative border border-solid border-light-100">
        <input className="w-full h-10 border-0 outline-0 shadow-none text-sm font-medium px-3"
          onChange={(e) => setText(e.target.value)}
        />
        <button className="absolute left-0 top-0 w-10 h-10 border-none outline-0 shadow-none flex justify-center items-center bg-primary-500 scale-[calc(1.05)] md:scale-100 md:bg-light-150 text-white md:text-light-400"><IconSearch width={24} height={32} /></button>
      </div>

      {loading && <span className="absolute inline-block left-11 top-0.5">
        <Loading width={36} height={36} className="text-primary-500" />
      </span>}

      {show && open &&
        <div
          ref={ref as any}
          onClick={e => e.stopPropagation()}
          className="absolute flex justify-between items-stretch right-0 left-0 mt-1 bg-white border border-solid shadow-sm rounded-sm z-[9999]"
        >
          <div className="w-full md:w-[64%]">
            {pData && pData?.map((item) => (
              <div className="flex justify-between px-3 py-2 cursor-pointer hover:bg-light-80" key={item?.uid}>
                <div className="border border-solid w-[60px] h-[60px]">
                  <Image width={60} height={60} alt="" src={item?.small_image?.url ?? 'noimage.jpg'} />
                </div>
                <div className="flex-1 flex flex-col justify-between pr-3">
                  <Link href={`/p/${item?.url_key}` ?? '#'} className="text-sm  font-normal text-default-100">
                    {item?.name}
                  </Link>
                  <span className="text-secondary-300 text-sm font-medium">موجود</span>
                </div>
              </div>
            ))}


            <div className="flex justify-end mt-3 p-3">
              <Link href={`/search/${searchTerm}`} className="text-sm px-6 py-2 font-medium text-white bg-primary-500 hover:bg-primary-700 shadow-md">
                همه موارد
              </Link>
            </div>
          </div>
          <div className="w-[1px] bg-light-170" />
          <div className="flex-col hidden md:flex w-[35%] p-3 justify-start items-stretch">
            <div>
              <p className="text-sm font-medium text-light-400 border-b border-solid border-light-170">دسته ها</p>
              <div>
                {cData && cData?.map((item) => (
                  <Link href={item?.url_path ?? "#"} key={item?.uid} className="text-sx block py-1">
                    {item?.name}
                  </Link>
                ))}
              </div>
            </div>



            {/* <div className="mt-4">
              <p className="text-sm font-medium text-light-400 border-b border-solid border-light-170">کلمات پیشنهادی</p>
              <div>
                {[...Array(3).keys()].map((item) => (
                  <Link href="#" key={item} className="text-xs block py-1">
                    کلمه {item + 1}
                  </Link>
                ))}
              </div>
            </div> */}

            {/* <div className="mt-4">
              <div className="flex justify-between items-center border-b border-solid border-light-170 ">
                <p className="text-sm font-medium text-light-400 ">مقالات مرتبط</p>
                <Link href="#" className="text-sm font-medium text-default-900">
                  همه موارد
                </Link>
              </div>
              <div>
                {[...Array(3).keys()].map((item) => (
                  <Link href="#" key={item} className="text-xs block py-1 w-[97%] text-overflow-custom">
                    باعث می‌شود برس به راحتی و به طور ثابت در دست قرار بگیرد تا{item + 1}
                  </Link>
                ))}
              </div>
            </div> */}
          </div>
        </div>}
    </div>
  )
})
